<template>
  <vc-toolbar-controls-right>
    <vc-button
      v-for="(link, index) in links"
      v-if="links.length"
      icon-button
      :tag="link.external ? 'a' : 'router-link'"
      :target="link.external ? '_blank' : '_self'"
      :key="index"
      :to="link.to"
      :color="color"
      :title="link.hint"
      :class="['ml-0']">
      <vc-icon>{{ link.icon }}</vc-icon>
    </vc-button>
  </vc-toolbar-controls-right>
</template>
<script>
export default {
  name: 'ToolbarLinks',
  data () {
    return {
      links: []
    }
  },
  props: {
    color: {
      type: String,
      required: true
    }
  },
  mounted () {
    this.links = this.$store.state.config.toolbarLinks
  }
}
</script>



// WEBPACK FOOTER //
// src/components/toolbar-links/ToolbarLinks.vue